import React, { useState } from "react";
import config from "../../config";
import {
  Container,
  Card,
  CardContent,
  Typography,
  TextField,
  Button,
  Box,
  Divider,
  MenuItem,
} from "@mui/material";
import axios from "axios";
import { toast } from 'react-toastify';

// Departments / modules an employee can belong to. The chosen department is
// stored on the user so they show up under the right module and reports.
const DEPARTMENTS = [
  "Management",
  "Front Office",
  "Housekeeping",
  "Spa",
  "Bar",
  "Restaurant",
  "Kitchen",
  "Laundry",
  "Maintenance",
  "Security",
  "Other",
];

export default function UserMaster() {
  const [name, setName] = useState("");
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [mobile, setMobile] = useState("");
  const [email, setEmail] = useState("");
  const [department, setDepartment] = useState("");
  const company = JSON.parse(sessionStorage.getItem("companyDetails"));
  const saveUser = async () => {
    if (!name || !username || !password || !mobile || !department) {
      toast.error("All fields including Department are required");
      return;
    }
    if (email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      toast.error("Please enter a valid email");
      return;
    }
    const companyid = company?.id;
    const token = sessionStorage.getItem("token");
    console.log(token);
    const payload = {
      name,
      username,
      password,
      mobile,
      email,
      companyid,
      department,
    };
    console.log(payload);

    try {
      await axios.post(
        `${config.API_BASE_URL}/Home/CreateUser`,
        payload,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      toast.success("User created successfully!");
      setName("");
      setUsername("");
      setPassword("");
      setMobile("");
      setEmail("");
      setDepartment("");
    } catch (err) {
      console.error("Error creating user:", err.response || err);
      toast.error(err.response?.data || "Failed to create user");
    }
  };

  return (
    <Container maxWidth="sm" sx={{ mt: 8 }}>
      <Card sx={{ borderRadius: 4, p: 2, boxShadow: 4 }}>
        <CardContent>
          <Typography variant="h5" align="center" sx={{ mb: 3, fontWeight: 700 }}>
            Create User
          </Typography>

          <Divider sx={{ mb: 3 }} />

          <Box display="flex" flexDirection="column" gap={2}>
            <TextField
              label="Name"
              fullWidth
              value={name}
              onChange={(e) => setName(e.target.value)}
            />

            <TextField
              label="Username"
              fullWidth
              value={username}
              onChange={(e) => setUsername(e.target.value)}
            />

            <TextField
              label="Password"
              type="password"
              fullWidth
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />

            <TextField
              label="Mobile"
              type="tel"
              inputProps={{ maxLength: 10 }}
              fullWidth
              value={mobile}
              onChange={(e) => setMobile(e.target.value)}
            />

            <TextField
              label="Email"
              type="email"
              fullWidth
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />

            <TextField
              select
              label="Department"
              fullWidth
              value={department}
              onChange={(e) => setDepartment(e.target.value)}
              helperText="Which module / department this employee belongs to">
              {DEPARTMENTS.map((d) => (
                <MenuItem key={d} value={d}>
                  {d}
                </MenuItem>
              ))}
            </TextField>

            <Button
              variant="contained"
              size="large"
              onClick={saveUser}
              sx={{ mt: 2 }}
            >
              Save User
            </Button>
          </Box>
        </CardContent>
      </Card>
    </Container>
  );
}
